import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/paypal': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M111.4 295.9c-3.5 19.2-17.4 108.7-21.5 134-0.3 1.8-1 2.5-3 2.5h-74.6c-7.6 0-13.1-6.6-12.1-13.9l58.6-371.9c1.5-9.6 10.1-16.9 20-16.9 152.3 0 165.1-3.7 204 11.4 60.1 23.3 65.6 79.5 44 140.3-21.5 62.6-72.5 89.5-140.1 90.3-43.4 0.7-69.5-7-75.3 24.2zM357.1 152c28.4 21.2 30.3 57.8 23.8 92.6-16.5 83.5-71.9 112.3-142.9 112.3-15 0-24.7-2.3-29.3 19.7-15.5 97.4-13.7 85.9-14.4 91.3-1.7 8.6-8.8 14.9-17.4 14.9h-63.5c-7.1 0-11.6-5.8-10.6-12.9 0 0 4.5-29.3 27.1-169.7 0.8-6.1 4.8-9.4 10.9-9.4 54 0 164.6 9.9 204.5-103.9 3.7-11.1 6.8-22.2 8.8-33.6 0.5-3.1 1.2-2.6 3-1.3z'
      }
    ]
  }
})
